/**
 * The configuration object for the Katapult Pro app. This variable is injected at:
 * - runtime by web-dev-server.config.mjs
 * - build time by rollup.config.js (and functions/rollup.config.js)
 * @type {import('../../../config.js').KatapultProConfig}
 */
const config = JSON.parse(
  /** @ts-ignore */
  __config__ || '{}'
);

// Set config as a global variable (only works in the browser)
if (typeof self != 'undefined') Object.assign(self, { config });

export { config };
